import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavController, PopoverController } from "@ionic/angular";
import { GlobalsService } from "src/app/api/globals.service";
import { UserComponent } from "src/app/components/user/user.component";
import { AuthConstants } from "src/app/config/auth-constants";
import { PerfilUser } from "src/app/Enum/perfilUser.enum";
import { ApiService } from "src/app/services/api.service";
import { AuthService } from "src/app/services/auth.service";
import { CartService } from "src/app/services/cart.service";
import { ProductosService } from "src/app/services/productos.service";
import { ReferidosService } from "src/app/services/referidos.service";
import { SearchService } from "src/app/services/search.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-private-layout",
  templateUrl: "./private-layout.component.html",
  styleUrls: ["./private-layout.component.scss"],
  animations: [
    trigger("fadeInOut", [
      state("void", style({ opacity: 0 })),
      state("*", style({ opacity: 1 })),
      transition("void => *", animate("1000ms ease-in")),
      transition("* => void", animate("1000ms ease-out")),
    ]),
  ],
})
export class PrivateLayoutComponent implements OnInit {
  perfil: number;
  PerfilUserEnum = PerfilUser;
  displayUserData: any;
  suscribeLicence: any;
  dataLoaded = false;
  textSearch: string;
  ismobile: boolean = false;
  Cronocoins: number = 0;
  username: string;
  cartLength: number;
  isIos = false;
  avatar: string = "assets/imagenes/sistema/user1.png";
  navigate = [
    {
      title: "Inicio",
      url: "/cursos",
      icon: "home",
      pos: 1,
      group: 1,
      activo: true,
    },
    {
      title: "Libros",
      url: "/libreria",
      icon: "book-outline",
      pos: 2,
      group: 2,
      activo: true,
    },
    {
      title: "Foros",
      url: "/forum",
      icon: "school-outline",
      pos: 3,
      group: 2,
      activo: true,
    },
    {
      title: "Cronocoins",
      url: "/cronocoins",
      icon: "logo-bitcoin",
      pos: 4,
      group: 3,
      activo: true,
    },
    {
      title: "Premium",
      url: "/mislibros",
      icon: "cloud-outline",
      pos: 5,
      group: 4,
      activo: false,
    },
    {
      title: "Perfil",
      url: "/profile",
      icon: "person-circle-outline",
      pos: 6,
      group: 4,
      activo: true,
    },
    {
      title: "Carrito",
      url: "/checkout",
      icon: "cart-outline",
      pos: 7,
      group: 4,
      activo: true,
    },
    {
      title: "Configuración",
      url: "/configuracion-privacidad",
      icon: "notifications-outline",
      pos: 9,
      group: 4,
      activo: true,
    },
    {
      title: "Contáctanos",
      url: "/contac",
      icon: "mail-outline",
      pos: 9,
      group: 4,
      activo: true,
    },
    {
      title: "Eliminar Cuenta",
      url: "/delete-acount",
      icon: "trash-outline",
      pos: 10,
      group: 4,
      activo: true,
    },
    {
      title: "Cerrar sesión",
      url: "/logout",
      icon: "close-outline",
      pos: 10,
      group: 4,
      activo: true,
    },
    {
      title: "Más",
      url: "#",
      icon: "caret-down-outline",
      pos: 10,
      group: 4,
      expanded: false,
      activo: true,
      items: [
        {
          title: "Quienes somos",
          url: "/whoAre",
          pos: 10,
          group: 4,
        },
        {
          title: "Trabaja con nosotros",
          url: "/work",
          pos: 10,
          group: 4,
        },
        {
          title: "Preguntas más frecuentes",
          url: "/ask",
          pos: 10,
          group: 4,
        },
        {
          title: "Términos y condiciones",
          url: "/termi",
          pos: 10,
          group: 4,
        },
        {
          title: "Tratamiento de datos",
          url: "/trata",
          pos: 10,
          group: 4,
        },
      ],
    },
  ];
  userPhoto: any;

  private _globalsIsMobileSub: any;

  constructor(
    private authService: AuthService,
    private service: ProductosService,
    private searchService: SearchService,
    public navCtrl: NavController,
    public globalsService: GlobalsService,
    private referidosService: ReferidosService,
    public cart: CartService,
    private popoverController: PopoverController,
    private api: ApiService
  ) {
    this.ismobile = globalsService.isMobile;
    this.isIos = globalsService.plataforma == "ios" ? true : false;

    // activa el premium solo cuando no es un ios 
    this.navigate.forEach((item) => {
      if (!item.activo && !this.isIos) {
        item.activo = true;
      }
    });

    // suscribirse a cambios de tamaño/plataforma
    if (globalsService && typeof globalsService.isMobile$ === "function") {
      this._globalsIsMobileSub = globalsService
        .isMobile$()
        .subscribe((val: boolean) => {
          this.ismobile = val;
        });
    }
    this.authService.suscribeLicence$.subscribe((res: any) => {
      this.authuser();
    });
    this.authService.userPerfil$.subscribe((res: number) => {
      this.perfil = res;
    });
    this.authService.addProducCar$.subscribe((data) => {
      this.cartLength = data;
    });
  }

  ngOnInit() {
    this.authuser();
  }

  ngOnDestroy(): void {
    if (this._globalsIsMobileSub && this._globalsIsMobileSub.unsubscribe) {
      this._globalsIsMobileSub.unsubscribe();
    }
  }

  authuser() {
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      this.getlicense();
      this.getTotalCar();
      this.getAvatar();
      this.username = this.displayUserData?.nombre_apellido;
      if (this.displayUserData?.tutorid != undefined) {
        this.username += " - " + this.displayUserData?.tutorname;
      }
      if (this.displayUserData?.id && this.displayUserData?.auth_key)
        this.referidosService
          .get(this.displayUserData?.id, this.displayUserData?.auth_key)
          .subscribe((res: any) => {
            this.Cronocoins = res.cronocoins;
          });
    });
  }
  getAvatar() {
    this.api
      .get(this.displayUserData.id, this.displayUserData.auth_key)
      .subscribe((res: any) => {
        console.log("🚀 ~ PrivateLayoutComponent ~ getAvatar ~ res:", res);
        if (res.auth_key) {
          if (res.img) {
            res.data.forEach((element) => {
              if (element.tipo != 1 && element.name) {
                this.avatar =
                  environment.host + "/" + element.url + element.name;
              }
            });
          }
        }
      });
  }
  getTotalCar() {
    this.cart.get(AuthConstants.CART).then((res) => {
      if (res.length) {
        this.cartLength = res.length;
      }
    });
  }

  getlicense() {
    this.service
      .getLicense(this.displayUserData.auth_key, this.displayUserData.id)
      .subscribe((response: any) => {
        this.suscribeLicence = response.suscripcion;
        this.dataLoaded = true;
      });
  }
  serchText() {
    this.searchService.event.emit(this.textSearch);
    if (this.textSearch != "") {
      this.navCtrl.navigateRoot("/search");
    }
  }

  toCheckout() {
    if (!this.cartLength || this.cartLength == 0) {
      return;
    }
    this.navCtrl.navigateRoot("/checkout");
  }

  async presentPopoverUser(ev: any) {
    const popover = await this.popoverController.create({
      component: UserComponent,
      cssClass: "config-pop-class",
      event: ev,
      translucent: true,
      mode: "ios",
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
    console.log("onDidDismiss resolved with role", role);
  }
}
